<template>
  <div class="fluid" :style="'width:' + this.width + 'px;'">
    <svg :height="imageHeight" :width="this.width">
      <polygon :points="bodyPoints" :style="'fill: ' + color + ';'" />
      <ellipse :cx="bottomEllipsis.cx" :cy="bottomEllipsis.cy" :rx="bottomEllipsis.rx" :ry="bottomEllipsis.ry" :style="'fill: ' + color + ';'" />
      <ellipse :cx="topEllipsis.cx" :cy="topEllipsis.cy" :rx="topEllipsis.rx" :ry="topEllipsis.ry" :style="'fill: ' + topColor + ';'" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'fluid',
  props: {
    color: {
      default: '#ffffff',
      type: String,
      required: true
    },
    height: {
      default: 300,
      type: Number
    },
    bottom: {
      default: 0,
      type: Number
    },
    maxHeight: {
      default: 300,
      type: Number
    },
    width: {
      default: 200,
      type: Number
    },
    padding: {
      default: 50,
      type: Number
    },
    diffTopBottom: {
      default: 0.25,
      type: Number
    }
  },
  computed: {
    topEllipsisRatio () {
      return 1 - ((1 - ((this.height + this.bottom) / this.maxHeight)) * this.diffTopBottom);
    },
    bottomEllipsisRatio () {
      return 1 - ((1 - (this.bottom / this.maxHeight)) * this.diffTopBottom);
    },
    topEllipsis () {
      return {
        cx: (this.width / 2),
        cy: this.imageHeight - (this.height + this.bottom) - this.padding,
        rx: (this.width / 2) * this.topEllipsisRatio,
        ry: (this.width / 5) * this.topEllipsisRatio
      };
    },
    bottomEllipsis () {
      return {
        cx: (this.width / 2),
        cy: this.imageHeight - (this.bottom) - this.padding,
        rx: (this.width / 2) * this.bottomEllipsisRatio,
        ry: (this.width / 5) * this.bottomEllipsisRatio
      };
    },
    bodyPoints () {
      let points = [
        [
          ((1 - this.topEllipsisRatio) / 2) * this.width,
          this.imageHeight - (this.height + this.bottom) - this.padding
        ],
        [
          this.width - (((1 - this.topEllipsisRatio) / 2) * this.width),
          this.imageHeight - (this.height + this.bottom) - this.padding
        ],
        [
          this.width - (((1 - this.bottomEllipsisRatio) / 2) * this.width),
          this.imageHeight - (this.bottom) - this.padding
        ],
        [
          ((1 - this.bottomEllipsisRatio) / 2) * this.width,
          this.imageHeight - (this.bottom) - this.padding
        ]
      ];

      return points.map(pair => pair.join(',')).join(' ');
    },
    imageHeight () {
      return this.maxHeight + (this.padding * 2);
    },
    topColor () {
      let rgb = [parseInt(this.color.substring(1, 3), 16), parseInt(this.color.substring(3, 5), 16), parseInt(this.color.substring(5, 7), 16)];
      rgb = rgb.map(value => Math.min(parseInt(value * 1.2, 10), 255))
      rgb = rgb.map(value => ((value.toString(16).length === 1) ? '0' + value.toString(16) : value.toString(16)));
      return '#' + rgb.join('');
    }
  }
}
</script>

<style lang="scss" scoped>
.fluid {
  margin: 0 auto;
}
</style>
